// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--EDh5R"};